import { aludraApi } from 'api/axios'

const mdl22 = {
  createNewListURL:
    'mdl22/products/productCustomList/addUpdateproductCustomList',
  searchQuickListsWithoutDetailURL:
    'mdl22/products/productCustomListGeneral/search',
  searchProductsByQuickListId:
    'mdl22/products/productCustomListGeneralByListId/search',
}

export const createQuickListService = payload => {
  return aludraApi.post(mdl22.createNewListURL, payload)
}

export const getQuickListsWithoutDetailService = payload => {
  return aludraApi.post(mdl22.searchQuickListsWithoutDetailURL, payload)
}

export const getProductsByQuickListIdService = payload => {
  return aludraApi.post(mdl22.searchProductsByQuickListId, payload)
}
